import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import Translation from '../../../lang/Translation';
import page from '../../../page/page';
import MediaQueries from '../../../style-helper/MediaQueries';
import Spinner from '../../ui/Spinner';
import CheckoutOverlay from '../CheckoutOverlay';

const useStyles = createUseStyles({
  orderProcessingOverlay: {
    padding: 20,
    margin: [0, 'auto'],
    textAlign: 'center',
  },
  spinner: {
    margin: [12, 'auto'],
  },
  message: {
    textAlign: 'center',
    margin: [0, 'auto'],
    width: '80%',
    
    [MediaQueries.phone]: {
      width: '90%',
    },
  },
});

export function OrderProcessingOverlay(props) {
  const classes = useStyles();
  let customMessage;
  
  const pageType = () => {
    if (page.isOnPage('payment-resolution') || page.isOnPage('payment-change')) {
      return 'paymentResolutionOrderProcessing';
    }
    return 'orderProcessing';
  };
  
  if (props.isSfExpress) {
    customMessage = 'messages.orderProcessing.content.smk';
  }
  
  return (
    <CheckoutOverlay>
      <div className={classes.orderProcessingOverlay} data-test="OrderProcessingOverlay">
        <h1 data-test="OrderProcessingOverlay__header" id="overlayLabel__id" tabIndex="-1">
          <Translation>{`messages.${pageType()}.title`}</Translation>
        </h1>
        <div className={classes.spinner} data-test="OrderProcessingPage__spinner">
          <Spinner size="small" />
        </div>
        <p className={classes.message} data-test="OrderProcessingOverlay__message">
          <Translation>{`messages.${pageType()}.content`}</Translation>
        </p>
        {customMessage && (
          <p className={classes.message} data-test="OrderProcessingOverlay__customMessage">
            <Translation>{customMessage}</Translation>
          </p>
        )}
      </div>
    </CheckoutOverlay>
  );
}

OrderProcessingOverlay.propTypes = {
  isSfExpress: PropTypes.bool.isRequired,
};

export default OrderProcessingOverlay;
